import { useEffect } from 'react';

/**
 * Hook para bloquear/desbloquear el scroll del body
 * Útil para modales, overlays, etc.
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      // Guardar el scroll actual
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      const body = document.body;
      const scrollY = window.scrollY;
      
      // Aplicar estilos para bloquear scroll
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.paddingRight = `${scrollBarWidth}px`;
      body.style.overflow = 'hidden';
      
      // Función de limpieza
      return () => {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.paddingRight = '';
        body.style.overflow = '';
        
        // Restaurar posición de scroll
        window.scrollTo(0, scrollY);
      };
    }
  }, [isLocked]);
};
